import * as React from 'react';
import {appendErrors} from 'react-hook-form';
export type NLSHiddenInputPropsType = {
  defaultValue: string;
  name: string;
  label: string;
  register: any;
  //rest: any | undefined;
  errors: any | undefined | null;
  validation: any;
};
export const NLSHiddenTextInput = ({
  defaultValue,
  name,
  label,
  register,
  errors,
  validation,
}: NLSHiddenInputPropsType) => {
  //console.log(errors[name]);
  return (
    <input
      id={name}
      name={name}
      type="text"
      hidden={true}
      defaultValue={defaultValue}
      {...register(name, validation)}
    />
  );
};
